var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"px-2 font-weight-bold",class:[_vm.color, _vm.textClass],attrs:{"filter":"","small":""}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.count)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }